import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import React from "react";
import { Link } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Comment from "shared/Comment/Comment";
import NcImage from "shared/NcImage/NcImage";
import SocialsList from "shared/SocialsList/SocialsList";
import Textarea from "shared/Textarea/Textarea";
import { Helmet } from "react-helmet-async";
import { useLanguage } from '../../contexts/languageContext';
import timelineImg from "images/timeline.jpg";
import scaledownverImg from "images/scaledownver.jpg";
import controlleruiImg from "images/controllerui.jpg";

const BlogSingle = () => {
  const { language, toggleLanguage } = useLanguage(); // Access language state

  const renderHeader = () => {
    return (
      <>
        {language === 'kr' && (
          <header className="container rounded-xl">
            <div className="max-w-screen-md mx-auto space-y-5">
              <Badge href="##" color="red" name="aerospace" />
              <Badge href="##" color="purple" name="tech" />
              <Badge href="##" color="blue" name="R&D" />
              <h1
                className=" text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl "
                title="Quiet ingenuity: 120,000 lunches and counting"
              >
                SwingX
              </h1>
              <span className="block text-base text-neutral-500 md:text-lg dark:text-neutral-400 pb-1">
                스윙X는 3축 시뮬레이터로 Roll, Pitch, Yaw 축의 변화를 정밀하게 측정하고 분석할 수 있는 모션 플랫폼과 드론 자세 제어, 우주 테마 파크 셔틀 시뮬레이터 등 응용 솔루션을 제공 합니다.
              </span>
              <span className="block text-base text-neutral-500 md:text-lg dark:text-neutral-400 pb-1">
                기술 보호와 글로벌 시장 경쟁력 독자적인 기술을 보호하기 위해 본 솔루션의 가동 방식에 대해 여러 국내외 특허를 보유하고 있으며 항공우주 분야의 다양한 요구에 대응할 수 있는 맞춤형 솔루션을 제공합니다. 이를 통해 첨단 기술 개발 및 검증을 위한 핵심 인프라의 새로운 벤치마킹 플랫폼으로 자리 잡고자 합니다.
              </span>
              <p>
                스윙X 프로덕트의 자세한 문의는 <a href="/#" target="_blank" rel="noopener noreferrer">
                  여기
                </a>{" "} 로 주세요.

              </p>

              <div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
              <div className="flex flex-col items-baseline sm:flex-row sm:justify-between">
                <div className="nc-PostMeta2 flex items-center flex-wrap text-neutral-700 text-left dark:text-neutral-200 text-sm leading-none flex-shrink-0">
                  <Avatar
                    containerClassName="flex-shrink-0"
                    sizeClass="w-8 h-8 sm:h-11 sm:w-11 "
                  />
                  <div className="ml-3">
                    <div className="flex items-center">
                      <a className="block font-semibold" href="/">
                        NAROSTP Writer
                      </a>
                    </div>
                    <div className="text-xs mt-[6px]">
                      <span className="text-neutral-700 dark:text-neutral-300">
                        3월 25, 2025
                      </span>
                      <span className="mx-2 font-semibold">·</span>
                      <span className="text-neutral-700 dark:text-neutral-300">
                        작성
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3">
                  <SocialsList />
                </div>
              </div>
            </div>
          </header>
        )}
        {language === 'en' && (
          <header className="container rounded-xl">
            <div className="max-w-screen-md mx-auto space-y-5">
              <Badge href="##" color="purple" name="blog" />
              <h1
                className=" text-neutral-900 font-semibold text-3xl md:text-4xl md:!leading-[120%] lg:text-4xl dark:text-neutral-100 max-w-4xl "
                title="Quiet ingenuity: 120,000 lunches and counting"
              >
                Aerospace Education Programs: Inspiring the Next Generation of Innovators and Explorers
              </h1>
              <span className="block text-base text-neutral-500 md:text-lg dark:text-neutral-400 pb-1">
                NaroSTP is committed to delivering dynamic and impactful aerospace education programs that cater to a wide range of audiences around the world, starting in Korea. We are the pioneer and by far the leader in the aerospace industry in Korea to develop and deliver quality learnings. From hands-on projects for aspiring engineers to exciting introductory activities for young children and the general public, our educational programs are designed to spark curiosity, foster skills, and provide real-world insights into the aerospace industry. Below is an overview of the diverse initiatives we offer, highlighting their content and target audiences. Contact us for more details!

              </span>
              <p>
                Also, check out           <a href="/#" target="_blank" rel="noopener noreferrer">
                  here
                </a>{" "} for the list of students and institutions we have worked with!

              </p>

              <div className="w-full border-b border-neutral-100 dark:border-neutral-800"></div>
              <div className="flex flex-col items-baseline sm:flex-row sm:justify-between">
                <div className="nc-PostMeta2 flex items-center flex-wrap text-neutral-700 text-left dark:text-neutral-200 text-sm leading-none flex-shrink-0">
                  <Avatar
                    containerClassName="flex-shrink-0"
                    sizeClass="w-8 h-8 sm:h-11 sm:w-11 "
                  />
                  <div className="ml-3">
                    <div className="flex items-center">
                      <a className="block font-semibold" href="/">
                        Fones Mimi
                      </a>
                    </div>
                    <div className="text-xs mt-[6px]">
                      <span className="text-neutral-700 dark:text-neutral-300">
                        May 20, 2021
                      </span>
                      <span className="mx-2 font-semibold">·</span>
                      <span className="text-neutral-700 dark:text-neutral-300">
                        6 min read
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3">
                  <SocialsList />
                </div>
              </div>
            </div>
          </header>
        )}
      </>
    );
  };

  const renderContent = () => {
    return (
      <>
        {language === 'kr' && (
          <div
            id="single-entry-content"
            className="prose dark:prose-invert prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
          >

            <blockquote>
              <p>
                소형 SwingX 플랫폼 시제품 사진들
              </p>
            </blockquote>

            <h3>
              <p>
                플랫폼 솔루션의 주요 특징
              </p>
            </h3>

            <ol>
              <li>3축 시뮬레이터 플랫폼
                <ul>
                  <li>서보모터 기반 PCB 및 자세제어 컨트롤러 알고리즘 탑재</li>
                </ul>
              </li>
              <li>
                드론 및 항공 시뮬레이션에 최적화
                <ul>
                  <li>넓은 각도 범위와 빠른 변화 속도를 제공</li>
                </ul>
              </li>
              <li>
                시스템 인터페이스/ 컨트롤러 UI
                <ul>
                  <li>Custom Input 값 옵션 제공</li>
                </ul>
                <ul>
                  <li>시스템 이상 유무 모니터링 기능을 통해 데이터 피드백과 테스트 환경 제공</li>
                </ul>
              </li>
            </ol>

            <figure>
              <img
                className="w-full h-full object-cover my-10 sm:my-12 "
                src={controlleruiImg}
                alt="hero"
              />
            </figure>

            <blockquote>
              <p>
                컨트롤러 UI 이미지
              </p>
            </blockquote>

            <h3>응용 분야 및 산업 확장 가능성</h3>
            <ol>
              <li>미래 항공 기술 연구 및 상용화를 위한 테스트 환경 구축
                <ul>
                  <li>스윙X는 단순한 드론 테스트를 넘어, 미래 항공 기술 연구 및 상용화를 위한 테스트 환경을 제공합니다. 차세대 무인기(UAV), 재사용 로켓, UAM(Urban Air Mobility) 연구 및 검증을 위한 핵심 인프라로 활용됩니다.</li>
                </ul>
              </li>
              <li>
                엔터테인먼트 산업의 실감형 컨텐츠 상용화
                <ul>
                  <li>항공우주 산업뿐만 아니라 다양한 산업군에서도 폭넓게 적용될 수 있습니다. 가상 공간에서의 이동·회전 및 중력 가속도를 사실적으로 구현할 수 있어, 놀이기구, 항공·우주 시뮬레이터, 자동차 경주 체험 등 엔터테인먼트 산업에도 접목될 수 있습니다. 또한 1인 탑승용 실사이즈 시제품을 개발하여 UAM 조종사 훈련, 항공우주박물관 및 과학관에서 활용할 수 있으며, 다인용 시뮬레이터 및 VR/AR/XR 기반 응용 제품으로도 시장 확장이 가능합니다.</li>
                </ul>
              </li>
            </ol>

            <figure>
              <img
                className="w-full h-full object-cover my-10 sm:my-12 "
                src={timelineImg}
                alt="hero"
              />
              {/* <img
                src="https://i.pinimg.com/736x/12/9d/4f/129d4f77185d727a722b5f895ead2743.jpg"
                alt="nc blog"
                className="rounded-2xl"
              />
              <figcaption>
                -
              </figcaption> */}
            </figure>

            <blockquote>
              <p>
                스윙X 프로덕트 타임라인
              </p>
            </blockquote>

          </div>
        )}
        {language === 'en' && (
          <div
            id="single-entry-content"
            className="prose dark:prose-invert prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
          >
            <h3>
              <p>
                Theories and Hands-On Projects: Building Cube Satellites
              </p>
            </h3>
            <p>
              One of our flagship programs focuses on empowering students and professionals to design, build, and test CubeSat satellites. We had in-house R&D for low cost satellites and we are using these innovations for our programs. This program integrates theoretical foundations with practical applications, guiding participants through:
            </p>
            <ol>
              <li>Orbital mechanics and satellite design principles.</li>
              <li>
                Developing and assembling CubeSat hardware components.
              </li>
              <li>
                Integrating payloads and conducting simulation tests.
              </li>
              <li>
                Launch preparation and post-launch analysis.
              </li>
            </ol>
            <p>
              Participants gain invaluable experience in project management, teamwork, and problem-solving while working with industry grade tools and equipments. This program has been particularly impactful for undergraduate engineering students and military personnel seeking specialized technical expertise.
            </p>

            <h3>Satellite Image Processing: LRIT Technology</h3>
            <p>
              Another core offering is our specialized workshop on processing Low Rate Information Transmission (LRIT) images. Participants delve into:
            </p>
            <ol>
              <li>
                Fundamentals of satellite communication systems.
              </li>
              <li>
                Basic C++
              </li>
              <li>
                Techniques to decode, decrypt and analyze LRIT image data.
              </li>
              <li>
                Error handling of LRIT data
              </li>
              <li>
                And finally visualizing into an image!
              </li>
            </ol>
            <p>This program equips students with advanced data analysis skills, essential for careers in satellite technology, meteorology, and geospatial sciences. Students will be learning from the professionals from the aerospace industry, such as KARI (link). Tertiary students and educators have found this workshop particularly valuable in enriching their curricula.
            </p>
            <blockquote>
              <p>
                우주 산업에 꿈을 그려온 우리가 프로그램을 통해 꿈을 향해 나아가고 발전할 수 있었던 기회
                출처 : 제주의소리(http://www.jejusori.net)
              </p>
            </blockquote>
            <figure>
              <img
                src="https://i.pinimg.com/736x/12/9d/4f/129d4f77185d727a722b5f895ead2743.jpg"
                alt="nc blog"
                className="rounded-2xl"
              />
              <figcaption>
                -
              </figcaption>
            </figure>
            <h3>
              <p>
                Theories and Hands-On Projects: Building Cube Satellites
              </p>
            </h3>
            <p>
              One of our flagship programs focuses on empowering students and professionals to design, build, and test CubeSat satellites. We had in-house R&D for low cost satellites and we are using these innovations for our programs. This program integrates theoretical foundations with practical applications, guiding participants through:
            </p>
            <ol>
              <li>Orbital mechanics and satellite design principles.</li>
              <li>
                Developing and assembling CubeSat hardware components.
              </li>
              <li>
                Integrating payloads and conducting simulation tests.
              </li>
              <li>
                Launch preparation and post-launch analysis.
              </li>
            </ol>
            <p>
              Participants gain invaluable experience in project management, teamwork, and problem-solving while working with industry grade tools and equipments. This program has been particularly impactful for undergraduate engineering students and military personnel seeking specialized technical expertise.
            </p>

            <h3>Aerospace Engineering Theories for Undergraduates</h3>
            <p>
              For mechanical engineering undergraduates with hopes to enhance their knowledge with aerospace engineering , we offer comprehensive courses covering:
            </p>
            <ol>
              <li>
                Aerodynamics, engines and propulsion systems.
              </li>
              <li>
                Structural analysis and materials for aerospace applications.
              </li>
              <li>
                Knowledge into the space environments and test planning
              </li>
            </ol>
            <p>
              These courses bridge the gap between mechanical engineering fundamentals and specialized aerospace concepts, preparing students for further studies or careers in the aerospace sector. Delivered by seasoned aerospace professionals, the program ensures theoretical depth coupled with real-world relevance.
            </p>

            <h3>High School Aerospace Curriculum</h3>
            <p>
              Our semester-long high school curriculum introduces students to the exciting world of aerospace engineering and sciences. The program includes:
            </p>
            <ol>
              <li>
                Basics of aerodynamics and space exploration.
              </li>
              <li>
                Design and construction of model rockets and gliders.
              </li>
              <li>
                Knowledge into the space environments and test planning
              </li>
              <li>
                Guidances to physical setup of space-related labs within the school compounds
              </li>
            </ol>
            <p>
              NaroSTP has been actively working with Hanlim Engineering High School in Jeju to develop Korea’s first aerospace engineering curriculum for the high school students. Our proposed curriculum is not just theoretical but also highly hands-on to inspire and challenge high school students.Through this curriculum, we hope students to foster creativity, critical thinking, and a passion for STEM. We are working with Jeju local government and the Korean Ministry of Education for this journey.
            </p>

            <h3>Upskilling Programs for Educators</h3>
            <p>
              To ensure the ripple effect of knowledge, we are also offering upskilling programs tailored for current tertiary educators and teachers. These programs include:
            </p>
            <ol>
              <li>
                Training in the latest aerospace technologies and teaching methodologies.
              </li>
              <li>
                Guidance on incorporating aerospace content into existing curricula.
              </li>
              <li>
                Hands-on workshops to enhance instructional skills.
              </li>
              <li>
                Field trips to the aerospace companies and institutions such as Kennedy Space Visitor Center in Florida, US and Johnson Space Center in Huston, US.
              </li>
            </ol>
            <p>
              Our upskilling initiatives are designed to empower educators and teachers with the tools, fine-tuned knowledge and confidence to guide and inspire their students effectively. Through the partnership with the education sector, we amplify the reach and impact of aerospace education. We are closely working with industry players such as KARI, Kennedy Space Visitor Center and Johnson Space Center for this effort.
            </p>

            <h3>Sparking Interest in Young Children</h3>
            <p>
              For the youngest minds, we conduct fun activities to ignite their curiosity about aerospace. We know that they just want to have fun! Programs include:
            </p>
            <ol>
              <li>
                Interactive storytelling about the universe and space exploration.
              </li>
              <li>
                Simple experiments and craft projects, such as building paper rockets and even our cube satellites!
              </li>
              <li>
                Field trips to the aerospace companies and institutions such as Kennedy Space Visitor Center in Florida, US and Johnson Space Center in Huston, US.
              </li>
            </ol>
            <p>
              Through conducting fun and educational activities, we aim to lay the foundation for a lifelong interest in science, technology, engineering, and mathematics fields (STEM). This will be their great first step into the field of aerospace.
            </p>

            <h3>Field Trips to Aerospace Industries</h3>
            <p>
              Nothing inspires like real-world exposure. We organize local and overseas field trips to leading aerospace facilities, offering participants a firsthand look at the industry in action. Highlights include:
            </p>
            <ol>
              <li>
                Visits to the Kennedy Space Center and Johnson Space Center in the United States.
              </li>
              <li>
                Tours of aerospace manufacturing and research facilities in Korea.
              </li>
              <li>
                Q&A sessions with aerospace engineers, scientists, industry leaders and even the astronauts!
              </li>
            </ol>
            <p>
              These field trips provide unique and unparalleled learning opportunities, allowing participants and students to connect theoretical knowledge with practical applications and industry trends.
            </p>

            <h3>Diverse Target Audiences</h3>
            <p>
              Our programs are tailored to meet the needs of various groups, including:
            </p>
            <ol>
              <li>
                <strong>Undergraduates: </strong>Hands-on projects and theoretical courses provide a strong foundation for aspiring aerospace professionals.
              </li>
              <li>
                <strong>Tertiary Educators:</strong> Upskilling workshops and curriculum equip educators with the latest tools and knowledge to inspire their students.
              </li>
              <li>
                <strong>High School Students:</strong> Comprehensive curricula introduce the exciting world of aerospace, fostering interest and skills in STEM.
              </li>
              <li>
                <strong>Military Personnel:</strong> Specialized training programs enhance technical skills relevant to defense applications.
              </li>
              <li>
                <strong>Young Children and the General Public:</strong> Fun, interactive activities spark curiosity and promote awareness about aerospace.
              </li>
            </ol>
            <p>
              These field trips provide unique and unparalleled learning opportunities, allowing participants and students to connect theoretical knowledge with practical applications and industry trends.
            </p>

            <h3>Expertise and Partnerships</h3>
            <p>
              Our programs are led by current and retired professionals from the aerospace industry, providing exposures and opportunities to participants to receive guidance from experts with extensive practical knowledge, know-hows and experience. Furthermore, our strong partnerships with institutions such as KARI, the Kennedy Space Center and Johnson Space Center augment our initiatives to provide unique opportunities to our participants and students which range from workshops, lessons to visits and collaborative projects. We are also working closely with the local governments, Korea MInistry of Education and schools to lay an aerospace learning journey for all.
            </p>

            <h3>Future Roadmap</h3>
            <p>
              Looking ahead, we aim to expand our collaborations with educational institutions, government agencies, and industry leaders. Our roadmap includes:
            </p>
            <ol>
              <li>
                Developing more specialized courses in emerging aerospace fields.
              </li>
              <li>
                Strengthening partnerships with global aerospace organizations.
              </li>
              <li>
                Expansion into online platforms for greater accessibility to our contents and programs.
              </li>
            </ol>
            <p>
              By continuously innovating and expanding our reach, we aspire to inspire and educate the next generation of aerospace pioneers.
            </p>

            <p>
              Our aerospace education programs reflect our commitment to nurturing curiosity, developing skills, and inspiring the future of exploration and innovation. Whether through hands-on workshops, advanced theoretical courses, or unforgettable field trips, we strive to make the wonders of aerospace accessible to everyone.
            </p>
          </div>
        )}      </>
    );
  };

  const renderTags = () => {
    return (
      <div className="max-w-screen-md mx-auto flex flex-wrap">
        <a
          className="nc-Tag inline-block bg-white text-sm text-neutral-600 dark:text-neutral-300 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
          href="##"
        >
          Garden
        </a>
        <a
          className="nc-Tag inline-block bg-white text-sm text-neutral-600 dark:text-neutral-300 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
          href="##"
        >
          Jewelry
        </a>
        <a
          className="nc-Tag inline-block bg-white text-sm text-neutral-600 dark:text-neutral-300 py-2 rounded-lg border border-neutral-100  md:px-4 dark:bg-neutral-700 dark:border-neutral-700 hover:border-neutral-200 dark:hover:border-neutral-6000 mr-2 mb-2"
          href="##"
        >
          Tools
        </a>
      </div>
    );
  };

  const renderAuthor = () => {
    return (
      <div className="max-w-screen-md mx-auto ">
        <div className="nc-SingleAuthor flex">
          <Avatar sizeClass="w-11 h-11 md:w-24 md:h-24" />
          <div className="flex flex-col ml-3 max-w-lg sm:ml-5 space-y-1">
            <span className="text-xs text-neutral-400 uppercase tracking-wider">
              WRITEN BY
            </span>
            <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-200">
              <a href="/">Fones Mimi</a>
            </h2>
            <span className="text-sm text-neutral-500 sm:text-base dark:text-neutral-300">
              There’s no stopping the tech giant. Apple now opens its 100th
              store in China.There’s no stopping the tech giant.
              <a className="text-primary-6000 font-medium ml-1" href="/">
                Readmore
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderCommentForm = () => {
    return (
      <div className="max-w-screen-md mx-auto pt-5">
        <h3 className="text-xl font-semibold text-neutral-800 dark:text-neutral-200">
          Responses (14)
        </h3>
        <form className="nc-SingleCommentForm mt-5">
          <Textarea />
          <div className="mt-2 space-x-3">
            <ButtonPrimary>Submit</ButtonPrimary>
            <ButtonSecondary>Cancel</ButtonSecondary>
          </div>
        </form>
      </div>
    );
  };

  const renderCommentLists = () => {
    return (
      <div className="max-w-screen-md mx-auto">
        <ul className="nc-SingleCommentLists space-y-5">
          <li>
            <Comment />
            <ul className="pl-4 mt-5 space-y-5 md:pl-11">
              <li>
                <Comment isSmall />
              </li>
            </ul>
          </li>
          <li>
            <Comment />
            <ul className="pl-4 mt-5 space-y-5 md:pl-11">
              <li>
                <Comment isSmall />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    );
  };

  const renderPostRelated = (post: PostDataType) => {
    return (
      <div
        key={post.id}
        className="relative aspect-w-3 aspect-h-4 rounded-3xl overflow-hidden group"
      >
        <Link to={post.href} />
        <NcImage
          className="object-cover w-full h-full transform group-hover:scale-105 transition-transform duration-300"
          src={post.featuredImage}
        />
        <div>
          <div className="absolute bottom-0 inset-x-0 h-1/2 bg-gradient-to-t from-black"></div>
        </div>
        <div className="flex flex-col justify-end items-start text-xs text-neutral-300 space-y-2.5 p-4">
          <Badge name="Categories" />
          <h2 className="block text-lg font-semibold text-white ">
            <span className="line-clamp-2">{post.title}</span>
          </h2>

          <div className="flex">
            <span className="block text-neutral-200 hover:text-white font-medium truncate">
              {post.author.displayName}
            </span>
            <span className="mx-1.5 font-medium">·</span>
            <span className="font-normal truncate">{post.date}</span>
          </div>
        </div>
        <Link to={post.href} />
      </div>
    );
  };

  return (
    <div className="nc-PageSingle pt-8 lg:pt-16 ">
      <Helmet>
        <title>SwingX</title>
      </Helmet>
      {renderHeader()}
      {/* <NcImage
        className="w-full rounded-xl"
        containerClassName="container my-10 sm:my-12 "
        src={imagePng}
      /> */}


      <figure>
        <img
          className="w-full h-full object-cover my-10 sm:my-12 "
          src={scaledownverImg}
          alt="hero"
        />
      </figure>


      <div className="nc-SingleContent container space-y-10">
        {renderContent()}
        {/* {renderTags()} */}
        <div className="max-w-screen-md mx-auto border-b border-t border-neutral-100 dark:border-neutral-700"></div>
        {/* {renderAuthor()}
        {renderCommentForm()}
        {renderCommentLists()} */}
      </div>
      {/* <div className="relative bg-neutral-100 dark:bg-neutral-800 py-16 lg:py-28 mt-16 lg:mt-24">
        <div className="container ">
          <h2 className="text-3xl font-semibold">Related posts</h2>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {DEMO_POSTS.filter((_, i) => i < 4).map(renderPostRelated)}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default BlogSingle;